<template>
  <div
    :class="['content-item', currentClickIndex === index ? 'click-transition' : '']"
    v-for="(item, index) in programList"
    :key="item.id"
    @click="handleClickProgramItem(item, index)"
  >
    <div class="content-item-num">
      {{ splitStart + index + 1 }}
    </div>
    <div class="content-item-right">
      <div class="item-right-top">
        <div class="right-top-name text-line-2">{{ item.name }}</div>
        <span class="right-top-date">{{ item.updateDate.split(" ")[0] }}</span>
      </div>
      <div class="item-right-bottom">
        <div class="right-bottom-item">
          <i class="v-icon-listen-times" />
          <span>{{ item.clickSum }}</span>
        </div>
        <div class="right-bottom-item file-item">
          <i class="v-icon-file" />
          <span>{{ item.fileSize }}</span>
        </div>
        <div class="right-bottom-download">
          <i class="v-icon-download-line" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "ColumnsList",
  props: {
    programList: Array,
    splitStart: Number
  },
  setup() {
    const router = useRouter();
    const currentClickIndex = ref(-1);
    const handleClickProgramItem = (item, index) => {
      console.log(item);
      currentClickIndex.value = index;
      setTimeout(() => {
        currentClickIndex.value = -1;
        if (item.workType != null && item.workType === 1) {
          // router.push({
          //   name: "ColumnsVideoPlay",
          //   query: {
          //     id: item.id,
          //     columnsId: item.columnsId
          //   }
          // });
          window.location.href = `https://hcfm.gztv.com:7443/filedata/hcfmSharePage/html/frm_ondemand_video.html?id=${item.id}`;
        } else {
          router.push({
            name: "ColumnsPlay",
            query: {
              id: item.id,
              columnsId: item.columnsId
            }
          });
        }
      }, 300);
    };

    return {
      currentClickIndex,
      handleClickProgramItem
    };
  }
});
</script>

<style lang="scss" scoped>
.content-item {
  display: flex;
  align-items: center;
  height: 85px;
  width: 100%;
  box-sizing: border-box;
  padding-left: 16px;

  .content-item-num {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9c9d9e;
    line-height: 22px;
    width: 30px;
    font-style: italic;
    margin-right: 5px;
  }

  .content-item-right {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    flex: 1;
    width: 100%;
    box-sizing: border-box;
    padding: 8px 10px 8px 2px;
    border-bottom: 1px solid rgba(232, 233, 234, 0.8);

    .item-right-top {
      display: flex;
      justify-content: space-between;

      .right-top-name {
        margin-right: 20px;
        width: 100%;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #272a2d;
        line-height: 22px;
        flex: 1;
      }

      .right-top-date {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #babbbc;
        line-height: 17px;
      }
    }

    .item-right-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .right-bottom-item {
        display: flex;
        align-items: center;
        margin-right: 20px;
        font-size: 12px;
        color: #babbbc;

        & span {
          margin-left: 5px;
        }

        .v-icon-listen-times,
        .v-icon-file,
        .v-icon-download-line {
          font-size: 16px;
        }
      }

      .file-item {
        flex: 1;
        margin-right: 30px;
      }

      .right-bottom-download {
        position: relative;
        min-width: 60px;
        display: flex;
        justify-content: flex-end;

        .confirm-download-icon {
          position: absolute;
          right: 0;
          bottom: 0;
          color: #e73828;
          transform: translate(30%, 20%);
          background: #fff;
          border: 2px solid #fff;
          border-radius: 50%;
          overflow: hidden;
        }
      }
    }
  }
}

.click-transition {
  animation: click-mode 0.2s linear;
}

@keyframes click-mode {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.96);
  }
  100% {
    transform: scale(1);
  }
}
</style>
